import React, { Component } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { TravelsFilter } from '../../index';
import marker from 'leaflet/dist/images/marker-icon.png'
import markerShadow from 'leaflet/dist/images/marker-shadow.png'
import './styles.css'

const icon =  L.icon({
  iconUrl: marker,
  shadowUrl: markerShadow,
  iconSize:     [25, 41],
  shadowSize:   [41, 41],
  iconAnchor:   [12.5, 41],
  shadowAnchor: [15, 41], 
  popupAnchor:  [0, 0]
});
let config = {
  params: {
    center: [42.698334,23.319941],
    zoomControl: false,
    zoom: 7,
    maxZoom: 18,
    minZoom: 2,
    scrollwheel: false,
    legends: true,
    infoControl: false,
    attributionControl: true
  },
  tileLayer: {
    uri: 'https://{s}.tile.thunderforest.com/pioneer/{z}/{x}/{y}.png?apikey=5c31ebcf50f64ebc87ae540757e0db12',
    params: {
      minZoom: 2,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
      id: '',
      accessToken: ''
    }
  }
};

export function stringToColor(string) {
  function hashCode(str) {
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
         hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      return hash;
  } 
  function intToRGB(i){
      var c = (i & 0x00FFFFFF)
          .toString(16)
          .toUpperCase();

      return "00000".substring(0, 6 - c.length) + c;
  }
  return '#' + intToRGB(hashCode(string))
}


let subwayLineNames = [];

class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      map: null,
      tileLayer: null,
      geojsonLayer: null,
      geojson: null,
      selectedManuscript: '*',
      selectedLocationType: '*',
      numEntrances: null
    };
    this._mapNode = null;
    this.updateMap = this.updateMap.bind(this);
    this.onEachFeature = this.onEachFeature.bind(this);
    this.pointToLayer = this.pointToLayer.bind(this);
    this.filterFeatures = this.filterFeatures.bind(this);
    this.filterGeoJSONLayer = this.filterGeoJSONLayer.bind(this);
  }

  styleFeature = (feature, event) => {
    return event=='hover' ? {
      color: stringToColor(feature.properties.manuscript),
      weight: 5,
      opacity: 1
    } : {
      color: stringToColor(feature.properties.manuscript),
      weight: 2,
      opacity: 0.8
    } 
  }
  
  componentDidMount() {
    if (!this.state.map) this.init(this._mapNode);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.geojson.features.length > 0 && this.state.map && !this.state.geojsonLayer) {
      this.addGeoJSONLayer(this.state.geojson);
    }
    if (
      this.state.selectedManuscript !== prevState.selectedManuscript ||
      this.state.selectedLocationType !== prevState.selectedLocationType
    ) {
      this.filterGeoJSONLayer();
    }
  }

  componentWillUnmount() {
    this.state.map.remove();
  }

  static getDerivedStateFromProps(props, state) {
    return {
        numEntrances: props.geojson.features.length,
        geojson: props.geojson
    }
  }


  updateMap({manuscript, locationType}) {
    if (manuscript === "- Всички ръкописи: -") {
      manuscript = "*";
    }
    this.setState({
      selectedManuscript: manuscript,
      selectedLocationType: locationType
    });
  }

  addGeoJSONLayer(geojson) {
    const geojsonLayer = L.geoJson(geojson, {
      onEachFeature: this.onEachFeature,
      pointToLayer: this.pointToLayer,
      filter: this.filterFeatures,
      style: this.styleFeature
    });
    geojsonLayer.addTo(this.state.map);
    this.setState({ geojsonLayer });
    // this.zoomToFeature(geojsonLayer);
  }

  filterGeoJSONLayer() {
    this.state.geojsonLayer.clearLayers();
    this.state.geojsonLayer.addData(this.state.geojson);
    this.zoomToFeature(this.state.geojsonLayer);
  }

  zoomToFeature(target) {
    var fitBoundsParams = {
      paddingTopLeft: [200,10],
      paddingBottomRight: [10,10]
    };
    if(Object.keys(target.getBounds()).length) {
      this.state.map.fitBounds(target.getBounds(), fitBoundsParams);
    } else {
      alert('Няма известно ' + this.state.selectedLocationType.toLowerCase() + ' на ' + this.state.selectedManuscript)
    }
  }

  filterFeatures(feature, layer) {
    return (
      (
        this.state.selectedLocationType === '*' ||
        (feature.geometry.type==="Point" && feature.properties.locationType === this.state.selectedLocationType)
      ) && (
        this.state.selectedManuscript === '*' || 
        feature.properties.manuscript === this.state.selectedManuscript
      )
    );
  }

  pointToLayer(feature, latlng) {
    var markerParams = {
      radius: 4,
      fillColor: 'orange',
      color: '#fff',
      icon: icon,
      weight: 1,
      opacity: 0.5,
      fillOpacity: 0.8
    };

    return L.marker(latlng, markerParams);
  }

  onEachFeature(feature, layer) {
    var self = this;
    var manuscript = feature.properties.manuscript;
    if (subwayLineNames.indexOf(manuscript) === -1) subwayLineNames.push(manuscript);
    var popup = document.createElement('div');
    popup.classList.add('popup');
    popup.innerHTML = `
    <h4 style='display:block;width:100%;'> ${ feature.properties.manuscript }</h4>
    ${feature.properties.notes || feature.properties.locationName ? `
    <input checked type="radio" name="popup${feature.properties.id}-tabs" id="tgl-popup${feature.properties.id}-tab1">
    `:''}
    <input type="radio" name="popup${feature.properties.id}-tabs" id="tgl-popup${feature.properties.id}-tab2">
    ${this.props.manuscripts[feature.properties.manuscript]['Други названия'] ? `    
        <input type="radio" name="popup${feature.properties.id}-tabs" id="tgl-popup${feature.properties.id}-tab3">
    `:''}
    <input type="radio" name="popup${feature.properties.id}-tabs" id="tgl-popup${feature.properties.id}-tab4">
    ${feature.properties.notes || feature.properties.locationName ? `
    <label for="tgl-popup${feature.properties.id}-tab1">Местоположение</label>
    `:''}
    <label for="tgl-popup${feature.properties.id}-tab2">За ръкописа</label>
    ${this.props.manuscripts[feature.properties.manuscript]['Други названия'] ? `
        <label for="tgl-popup${feature.properties.id}-tab3">Други названия</label>
    `:''}
    <label for="tgl-popup${feature.properties.id}-tab4">Библиография</label>
    ${feature.properties.notes || feature.properties.locationName ? `
    <div id="popup${feature.properties.id}-tab1">
        <h5>${feature.properties.locationType}: ${feature.properties.locationName.replace(/\d+\./gi, '')}</h5>
        ${feature.properties.authenticName && `Възрожденско име на местоположението: ${feature.properties.authenticName}`}
        <p><strong>Забележка:</strong><br/> ${feature.properties.notes}</p>
        </div>
    `:''}    
    <div id="popup${feature.properties.id}-tab2">
    <table border="1" cellspacing="2">
    ${Object.keys(this.props.manuscripts[feature.properties.manuscript]).filter(key => ['Библиография на паспорта', 'Забележка', 'Други названия', 'Възрожденско име на местоположението'].indexOf(key) == -1).map(key => {
        var value = this.props.manuscripts[feature.properties.manuscript][key];
        return `<tr><td>${key}: </td><td>${value}</td></tr>`
    }).join('')}
    </table>
    </div>
    ${this.props.manuscripts[feature.properties.manuscript]['Други названия'] ? `<div id="popup${feature.properties.id}-tab3">
            <ul>
                ${this.props.manuscripts[feature.properties.manuscript]['Други названия'].split(';').map(item => '<li>'+item+'</li>').join('') }
            </ul>
        </div>`
    :''}
    ${this.props.manuscripts[feature.properties.manuscript]['Библиография на паспорта'] ? `<div id="popup${feature.properties.id}-tab4">
        <ul>
            ${this.props.manuscripts[feature.properties.manuscript]['Библиография на паспорта'].split(';').filter(item=>item!=='#N/A').map(item => '<li>'+item+'</li>').join('') }
        </ul>
    </div><strong style="display: block; padding: 20px 0; opacity: .7">&copy; Автор: доц. д-р Мила Кръстева</strong>`
    :''}
    `
    subwayLineNames.sort();
    if (subwayLineNames.indexOf('- Всички ръкописи: -') === -1) subwayLineNames.unshift('- Всички ръкописи: -');
    layer.bindPopup(popup, {maxHeight: 300, maxWidth: 470})
    layer.on('mouseover', function(e) {
      if(layer.feature.geometry.type==="LineString"){
        layer.setStyle(self.styleFeature(feature, 'hover'))
      }
    })
    layer.on('mouseout', function(e) {
      if(layer.feature.geometry.type==="LineString"){
        layer.setStyle(self.styleFeature(feature, ''))
      }
    })
  }

  init(id) {
    if (this.state.map) return;
    let map = L.map(id, config.params);
    L.control.zoom({ position: "bottomleft"}).addTo(map);
    L.control.scale({ position: "bottomleft"}).addTo(map);
    const tileLayer = L.tileLayer(config.tileLayer.uri, config.tileLayer.params).addTo(map);
    this.setState({ map, tileLayer });
  }

  render() {
    const { selectedManuscript } = this.state;
    return (
      <div id="mapUI">
        {
          subwayLineNames.length &&
            <TravelsFilter lines={subwayLineNames}
              curFilter={selectedManuscript}
              filterLines={this.updateMap} />
        }
        <div ref={(node) => this._mapNode = node} id="map" />
      </div>
    );
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/modules/Travels/components/TravelsMap/index.js